<template>
  <div class="line">
    <div class="box">
      <div class="addBox">
        <div class="body">
          <ul class="scroll">
            <li v-for="(spotItem, index) in spotOptionList" :key="index">
              <ul>
                <li class="addBox-title">
                  点{{ index + 1 }}名称
                  <el-input v-model="spotItem.title"></el-input>
                </li>
                <li class="latlngBox">
                  经度
                  <div class="latlngDiv">
                    <el-input
                      type="number"
                      max="180"
                      min="-180"
                      oninput="if(value>180)value=180;if(value.length>3)value=value.slice(0,3);if(value<-180)value=-180"
                      v-model="spotItem.lode"
                    ></el-input
                    >°
                    <el-input
                      type="number"
                      max="60"
                      min="0"
                      oninput="if(value>60)value=60;if(value.length>3)value=value.slice(0,3);if(value<0)value=0;value=value.replace(/[^\d]/g,'');"
                      v-model="spotItem.lomin"
                    ></el-input
                    >'
                    <el-input
                      type="number"
                      max="60"
                      min="0"
                      oninput="if(value>60)value=60;if(value.length>3)value=value.slice(0,3);if(value<0)value=0;value=value.replace(/[^\d]/g,'');"
                      v-model="spotItem.lose"
                    ></el-input
                    >"
                  </div>
                </li>
                <li class="latlngBox">
                  纬度
                  <div class="latlngDiv">
                    <el-input
                      type="number"
                      max="90"
                      min="-90"
                      oninput="if(value>90)value=90;if(value.length>3)value=value.slice(0,3);if(value<-90)value=-90"
                      v-model="spotItem.lade"
                    ></el-input
                    >°
                    <el-input
                      type="number"
                      max="60"
                      min="0"
                      oninput="if(value>60)value=60;if(value.length>3)value=value.slice(0,3);if(value<0)value=0;value=value.replace(/[^\d]/g,'');"
                      v-model="spotItem.lamin"
                    ></el-input
                    >'
                    <el-input
                      type="number"
                      max="60"
                      min="0"
                      oninput="if(value>60)value=60;if(value.length>3)value=value.slice(0,3);if(value<0)value=0;value=value.replace(/[^\d]/g,'');"
                      v-model="spotItem.lase"
                    ></el-input
                    >"
                  </div>
                </li>

                <li @click="addPoint(index)">
                  <span>
                    <i class="el-icon-plus"></i>
                  </span>
                </li>
                <li @click="removePoint(index)">
                  <span>
                    <i class="el-icon-minus"></i>
                  </span>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div class="foot">
          <el-button @click="cancelDraw">取消</el-button>
          <el-button @click="draw" type="primary">确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addLine, updateLine, saveCustomRoute } from "../../../../request/api";
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      hdData: ["航线名称"],
      typeShow: false,
      recomList: [1, 2, 3, 4],
      form: {
        roundtrip: 1,
        points: [],
        strokecolor: "",
        strokeweight: null,
        opacity: null,
      },
      darwStatus: false,
      unit: "",
      spotOptionList: [
        {
          lode: "",
          lomin: "",
          lose: "",
          lade: "",
          lamin: "",
          lase: "",
          isdroppoint: 1,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      editId: "draw/editId",
      showAdd: "draw/showAdd",
      showEdit: "draw/showEdit",
      showDrawConsole: "draw/showDrawConsole",
    }),
  },
  watch: {},
  methods: {
    ...mapActions({
      stopDrawAction: "drawMap/stopDrawAction",
      startDataDrawAction: "drawMap/startDataDrawAction",
      customRouteListAction: "rightCon/customRouteListAction",
    }),
    ...mapMutations({
      startDataDrawDiaAction: "drawMap/startDataDrawDia",
      stopDrawDiaAction: "drawMap/stopDrawDia",
      changeAddCustomIsShow: "rightCon/changeAddCustomIsShow",
    }),
    handleClose(done) {
      done();
    },
    cancelDraw() {
      this.darwStatus = false;
      this.$emit("cancelDrawToMap");
      this.spotOptionList = [
        {
          lode: "",
          lomin: "",
          lose: "",
          lade: "",
          lamin: "",
          lase: "",
          isdroppoint: "",
        },
      ];
    },
    darwDetail(res) {
      this.form.points = res.points;
      this.spotOptionList = [];
      res.points.forEach((item) => {
        let loDegrees = ToDegrees(item.lo);
        let laDegrees = ToDegrees(item.la);
        let spotOption = {
          title: item.title,
          lode: loDegrees[0],
          lomin: loDegrees[1],
          lose: loDegrees[2],
          lade: laDegrees[0],
          lamin: laDegrees[1],
          lase: laDegrees[2],
          height: item.height,
          heighttype: item.heighttype,
          isdroppoint: item.isdroppoint,
        };
        this.spotOptionList.push(spotOption);
      });
    },
    draw() {
      this.stopDrawAction();
      var latlngs = [];
      this.form.points = [];
      console.log(this.spotOptionList);
      this.spotOptionList.forEach((item, index) => {
        let spotOption = {};
        spotOption.sortno = index;
        spotOption.lo = ToDigital(item.lode, item.lomin, item.lose) - 0;
        spotOption.la = ToDigital(item.lade, item.lamin, item.lase) - 0;
        spotOption.isdroppoint = item.isdroppoint;
        let latlng = [spotOption.la, spotOption.lo];
        latlngs.push(latlng);
        this.form.points.push(spotOption);
      });

      if (this.form.points.length < 2) {
        this.$message({
          message: "航路点少于2",
          type: "warning",
        });
        return;
      }
      var drawLayer = new L.Polyline.AntPath(latlngs, {
        color: "#00cf5d",
        delay: 300,
        dashArray: [10, 20],
        weight: 6,
        paused: false,
        reverse: false,
        hardwareAccelerated: true,
      });
      drawLayer.addTo(map);
      this.$emit("cancelDrawToMap");
    },
    async confrim() {
      if (!this.darwStatus) {
        this.$fire({
          title: "请先绘制",
          type: "warning",
        }).then((r) => {});
        return;
      }

      if (this.form.points.length < 2) {
        this.$message({
          message: "航路点少于2",
          type: "warning",
        });
        return;
      }
      let res = await saveCustomRoute(this.form);
      if (res.code === 200) {
        this.$message({
          message: "添加航线成功",
          type: "success",
        });
        this.$emit("transferParamline", res.route);
        this.cancelDraw();
      }
      this.customRouteListAction();
    },
    getType(status) {
      if (status === "ORDINARY") {
        return "普通";
      } else if (status === "LIMITED") {
        return "限定";
      } else if (status === "NOFLY") {
        return "禁飞";
      } else if (status === "CONFLICT") {
        return "冲突";
      }
    },
    async edit() {
      if (!this.darwStatus) {
        this.$fire({
          title: "请先绘制",
          type: "warning",
        }).then((r) => {});
        return;
      }
      if (this.form.points.length < 2) {
        this.$message({
          message: "航路点少于2",
          type: "warning",
        });
        return;
      }
      let editForm = { ...this.form };
      editForm.id = this.editId;
      let res = await updateLine(editForm);
      if (res.code === 200) {
        this.$message({
          message: "修改航线成功",
          type: "success",
        });
        this.$eventBus.$emit("getList");
      }
    },
    addPoint(index) {
      let spotOption = {
        lode: "",
        lomin: "",
        lose: "",
        lade: "",
        lamin: "",
        lase: "",
        isdroppoint: "",
      };
      this.spotOptionList.splice(index + 1, 0, spotOption);
    },
    removePoint(index) {
      if (index === 0) {
        console.log(this.spotOptionList);
        if (this.spotOptionList.length < 2) {
          return;
        }
      }
      this.spotOptionList.splice(index, 1);
    },
  },

  mounted() {},
};
</script>


<style lang="less" scoped>
.line {
  position: relative;
  bottom: 0;
}

input {
  background-color: transparent;
}

.box {
  position: relative;
  left: 0;
  z-index: 1002;
  color: #fff;
}

.addBox {
  .body {
    width: 100%;

    .scroll {
      height: 200px;
      overflow: scroll;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .scroll li {
      height: 35px;
      line-height: 35px;
      float: none;
      width: 100%;
      margin: 0;
      font-size: 12px;
      margin-bottom: 15px;

      .addBox-title {
        width: 160px;

        .el-input {
          width: 70%;
        }
      }

      .latlngBox {
        width: 190px;

        .latlngDiv {
          width: 80%;
          float: right;
          display: flex;
          justify-content: space-evenly;
        }
      }

      ul li {
        float: left;
        width: 112px;
        margin: 0 2px;

        &:nth-child(4),
        &:nth-child(5) {
          width: 45px;
          line-height: 45px;
          position: relative;
          cursor: pointer;

          span {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -43%);
            width: 33px;
            height: 35px;

            i {
              font-size: 30px;
            }
          }
        }
      }
    }
  }

  .foot {
    text-align: right;
    font-size: 12px;
  }
}

.layui-btn {
  height: 28px;
  line-height: 28px;
  border: 1px solid transparent;
  padding: 0 18px;
  background-color: #57a3f3;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  font-size: 14px;
  border-radius: 2px;
  cursor: pointer;
}

.clearfix {
  display: flex;
  color: #fff;
  justify-content: space-between;
}
</style>